<template>
  <div class="boolean-input">
    <div class="form-group">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 control-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <div class="radio">
          <label>
            <input type="radio" value=""
              :name="options.name"
              :checked="value === ''"
              @change="$emit('input', '')"/>
            Any
          </label>
        </div>
        <div class="radio">
          <label>
            <input type="radio" value="true"
            :name="options.name"
            :checked="value === 'true'"
            @change="$emit('input', 'true')"/>
            Yes
          </label>
        </div>
        <div class="radio">
          <label>
            <input type="radio" value="false"
            :name="options.name"
            :checked="value === 'false'"
            @change="$emit('input', 'false')"/>
            No
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BooleanInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      isValid: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/BooleanInput.vue